import {Component, inject, OnInit, Renderer2, signal, ViewChild} from '@angular/core';
import {APIService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {TableComponent, TableOptions} from '@shared/components';
import {HttpHeaders} from '@angular/common/http';
import {PastIllness} from '@core/classes/tables/past-illness';
import {NavigationEnd, Router} from '@angular/router';
import {Allergy} from '@core/classes/tables/allergy';
import {
  PastIllnessStatusActionComponent
} from '@modules/cy/patient/ps/components/past-illnesses/actions/past-illness-status-action/past-illness-status-action.component';
import {
  AddPastIllnessComponent
} from '@modules/cy/patient/ps/components/past-illnesses/actions/add-past-illness/add-past-illness.component';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'ncp-past-illnesses',
  imports: [
    TableComponent
  ],
  templateUrl: './past-illnesses.component.html',
  styleUrl: './past-illnesses.component.scss',
})
export class PastIllnessesComponent implements OnInit {
  @ViewChild('pastIllness') public pastIllnessEl!: TableComponent<PastIllness>;
  protected readonly router = inject(Router);
  protected apiService = inject(APIService);
  protected patientService = inject(PatientService);
  protected renderer2 = inject(Renderer2);

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected options = signal<TableOptions<PastIllness>>(
    new TableOptions<PastIllness>({
      id: 'pastIllness',
      type: 'PastIllness',
      interface: PastIllness,
      autoLoadData: false,
      ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit')? [] : ['status'],
      pagination: {
        itemsPerPage: 10,
        pageNumber: 1,
        totalItems: 0,
      },
      searchComponent: null,
    })
  );

  ngOnInit(): void {
    this.getData(
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0,
      (this.router.url === '/cy/patient/ps/edit' || this.router.url === '/cy/patient/ps/create') ? -1 : 0
    );

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.subscription) {
          this.subscription.unsubscribe();
        }
      }
    });
  }

  protected getData = (mode: number = 0, status: number = 0) => {
    this.subscription = this.apiService
      .call({
        path: '/get-illness',
        headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
        body: {
          mode: mode,
          status: status,
          version_id: this.patientService.patient?.version?.id || -1
        }
      })?.pipe(takeUntil(this.destroy$)).subscribe((response: any) => {
      if(response && response.status === 1) {
        this.options.set(
          new TableOptions<PastIllness>({
            id: 'pastIllness',
            type: 'PastIllness',
            interface: PastIllness,
            data: response.data,
            autoLoadData: false,
            ignoreColumns: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? [] : ['status'],
            actionsComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? PastIllnessStatusActionComponent : undefined,
            extraComponent: (this.router.url === '/cy/patient/ps/create' || this.router.url === '/cy/patient/ps/edit') ? AddPastIllnessComponent : undefined,
            pagination: {
              itemsPerPage: 10,
              pageNumber: 1,
              totalItems: response.data.length,
            },
            renderCustomRow: (td: HTMLTableCellElement, row: {}, item: string) => {
              const data = row as Allergy;
              if (item === 'status') {
                td.innerHTML = '';

                let iEl = this.renderer2.createElement('h2');
                if(data.status === 1) {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye');
                  this.renderer2.addClass(iEl, 'text-primary');
                } else {
                  this.renderer2.addClass(iEl, 'bi');
                  this.renderer2.addClass(iEl, 'bi-eye-slash');
                  this.renderer2.addClass(iEl, 'text-secondary');
                }
                this.renderer2.appendChild(td, iEl);
              }
            },
            searchComponent: null,
          })
        );
      }
    })
  }
}
